import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button, Modal, ModalBody, Text } from "@wojo/ui";
import React, { useState } from "react";
import { useWatch } from "react-hook-form";

export const QuoteTravelersSoloModal: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { productPage } = useI18n("productPage");
    const nbTravelers = useWatch({ name: "nbTravelers" });
    const modalBtnLabel =
        productPage.tripBuilder.quote.travelers.soloTraveler.modalButtonLabel.l();
    const soloHeader =
        productPage.tripBuilder.quote.travelers.soloTraveler.heading.l();

    if (!modalBtnLabel || !soloHeader || nbTravelers !== 1) {
        return null;
    }

    return (
        <>
            <span>
                {productPage.tripBuilder.quote.travelers.soloTraveler.note.l()}{" "}
                <Button
                    variant="quiet"
                    type="button"
                    onClick={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "TRIP_BUILDER",
                                ga4_action: "MODAL_OPENED",
                                modalId: "Solo Traveler Info",
                            },
                        });
                        setIsOpen(true);
                    }}
                    style={{ fontSize: "inherit" }}
                >
                    {modalBtnLabel}{" "}
                    <span className="visually-hidden">: {soloHeader}</span>
                </Button>
            </span>
            <Modal
                onCloseRequested={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "MODAL_CLOSED",
                            modalId: "Solo Traveler Info",
                        },
                    });
                    setIsOpen(false);
                }}
                isOpen={isOpen}
                accessibleTitle={soloHeader}
            >
                <ModalBody>
                    <Text.Heading tag="h2" order="3">
                        {soloHeader}
                    </Text.Heading>
                    <Text style={{ marginTop: "var(--g-spacing-sm" }}>
                        {productPage.tripBuilder.quote.travelers.soloTraveler.description.l()}
                    </Text>
                </ModalBody>
            </Modal>
        </>
    );
};
